import React, { useRef, useCallback } from 'react';

const ProfileCardComponent = ({
  name          = '',
  title         = '',
  stars         = 0,
  starColor     = '#E2FF00',
  avatarUrl     = '',
  glowColor     = 'rgba(125,190,255,0.5)',
  innerGradient = 'linear-gradient(145deg,#1a1a2e 0%,#16213e 100%)',
  cardHeight    = '',
  cardWidth     = '',
}) => {
  const cardRef = useRef(null);
  const rafRef  = useRef(null);

  const handleMouseMove = useCallback((e) => {
    const card = cardRef.current;
    if (!card) return;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const cx = rect.width  / 2;
      const cy = rect.height / 2;
      const rx = ((y - cy) / cy);
      const ry = ((x - cx) / cx);
      card.style.setProperty('--ratio-x', ry.toFixed(3));
      card.style.setProperty('--ratio-y', rx.toFixed(3));
      card.style.setProperty('--mx', `${(x / rect.width  * 100).toFixed(1)}%`);
      card.style.setProperty('--my', `${(y / rect.height * 100).toFixed(1)}%`);
      card.style.setProperty('--active', '1');
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    const card = cardRef.current;
    if (!card) return;
    card.style.setProperty('--ratio-x', '0');
    card.style.setProperty('--ratio-y', '0');
    card.style.setProperty('--active', '0');
  }, []);

  return (
    <div
      ref={cardRef}
      className="holo-card"
     style={{
  '--glow-color': glowColor,
  '--inner-gradient': innerGradient,
  '--star-color': starColor,
  '--ratio-x': '0',
  '--ratio-y': '0',
  '--mx': '50%',
  '--my': '50%',
  '--active': '0',
  ...(cardHeight ? { '--holo-height': `${cardHeight}px` } : {}),
  ...(cardWidth  ? { '--holo-width':  `${cardWidth}px`  } : {}),
}}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {/* Glow behind */}
      <div className="holo-glow" />

      {/* Card face */}
      <div className="holo-face">
        {/* Holographic shine layer */}
        <div className="holo-shine" />
        {/* Glare */}
        <div className="holo-glare" />

        {/* Logo */}
        <div className="holo-logo">
          {avatarUrl
            ? <img src={avatarUrl} alt={name} className="holo-img" onError={e => e.target.style.display='none'} />
            : <div className="holo-logo-placeholder" />
          }
        </div>

        {/* Text */}
        <div className="holo-text">
          <h3 className="holo-name">{name}</h3>
          <p className="holo-title">{title}</p>
          {stars > 0 && (
            <div className="holo-stars">
              {[1,2,3,4,5].map(i => (
                <span key={i} className="holo-star"
                  style={{ color: i<=stars ? starColor : 'rgba(255,255,255,0.12)', textShadow: i<=stars ? `0 0 6px ${starColor}` : 'none' }}>
                  ★
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ProfileCard = React.memo(ProfileCardComponent);
export default ProfileCard;